import { DraftGroup } from "../draftState";
import { NestedEditorRow } from "./nestedRowTypes";
import { resolveMultiDragTopLevelRows } from "./nestedMultiDragRules";

const indexRowsById = (
    rows: NestedEditorRow[],
): Map<string, NestedEditorRow> => {
    const rowsById = new Map<string, NestedEditorRow>();
    const visit = (row: NestedEditorRow): void => {
        rowsById.set(row.id, row);
        row.children?.forEach(visit);
    };
    rows.forEach(visit);
    return rowsById;
};

// The full set of row ids a drag of `activeRow` will move — the moving roots
// (active row, or the whole multi-selection) each expanded to include their
// group descendants in the tree. Drives the "lifted" treatment applied to every
// row in the drag set so the user sees the whole set being picked up.
export const collectNestedActiveDragRowIds = ({
    activeRow,
    selectedDraggableRows,
    nestedRows,
    groups,
}: {
    activeRow: NestedEditorRow;
    selectedDraggableRows: NestedEditorRow[];
    nestedRows: NestedEditorRow[];
    groups: DraftGroup[];
}): string[] => {
    // Multi-select drag moves the resolved selected set; otherwise just the
    // active row.
    const rootRows = resolveMultiDragTopLevelRows({
        activeRow,
        selectedDraggableRows,
        groups,
    }) ?? [activeRow];
    const rowsById = indexRowsById(nestedRows);
    const ids: string[] = [];
    const collect = (row: NestedEditorRow): void => {
        ids.push(row.id);
        row.children?.forEach(collect);
    };
    rootRows.forEach((root) => collect(rowsById.get(root.id) ?? root));
    return ids;
};
